const REJECT_APPROVAL_STATUS = 'REJECT';
const APPROVE_APPROVAL_STATUS = 'APPROVE';
const ASSIGN_APPROVAL_STATUS = 'ASSIGNAPPROVER';

const APPROVAL_HISTORY_STATUSES_FIXED = {
  0: 'Pending',
  1: 'Approved',
  2: 'Rejected',
  3: 'Hold',
  4: 'More Information',
  5: 'Cancelled',
  6: 'Error',
  7: 'Closed',
};

// Mobile CRQs return approval.status as the text of the status
// but Fixed CRQs require lookup. For convenience, we just check the
// status value against the lookup for FIXED, and if none is returned
// we just return the passed in status
const getStatusNameForApproval = (status) => {
  if (!status) return status;
  const displayValueFixed = APPROVAL_HISTORY_STATUSES_FIXED[status];
  return displayValueFixed ? displayValueFixed : status;
};

export {
  getStatusNameForApproval,
  REJECT_APPROVAL_STATUS,
  APPROVE_APPROVAL_STATUS,
  ASSIGN_APPROVAL_STATUS,
};


